import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // lista de dispositivos indexada por id
  items: {},

  // dispositivo atualmente selecionado
  selectedId: null,

  // timestamp da última seleção
  selectTime: null,

  // 🔥 NOVO: controla modo foco (zoom + esconder outros)
  focusMode: false,
};

const { reducer, actions } = createSlice({
  name: 'devices',
  initialState,
  reducers: {
    // Atualiza lista inteira
    refresh(state, action) {
      state.items = {};
      if (Array.isArray(action.payload)) {
        action.payload.forEach((item) => {
          if (item?.id !== undefined) {
            state.items[item.id] = item;
          }
        });
      }
    },

    // Atualiza parcialmente dispositivos
    update(state, action) {
      if (Array.isArray(action.payload)) {
        action.payload.forEach((item) => {
          if (item?.id !== undefined) {
            state.items[item.id] = item;
          }
        });
      }
    },

    // Seleciona um dispositivo
    selectId(state, action) {
      state.selectTime = Date.now();
      state.selectedId = action.payload ?? null;
    },

    // 🔥 Ativa ou desativa modo foco
    setFocusMode(state, action) {
      state.focusMode = !!action.payload;
    },

    // 🔥 Limpa seleção e sai do modo foco
    clearSelection(state) {
      state.selectedId = null;
      state.focusMode = false;
      state.selectTime = null;
    },

    // Remove dispositivo
    remove(state, action) {
      if (action.payload !== undefined) {
        delete state.items[action.payload];
      }
    },
  },
});

export { actions as devicesActions };
export { reducer as devicesReducer };